import React from 'react';

export default function LogoutPage() {
    React.useEffect(()=> {
        window.localStorage.clear('ds-token');
        window.location.href = '/login'
    })
}